import { getAuthToken } from "jwt-storage-lib";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BuildSettings } from "@builder/types/BuildSettings";

export const buildSettingsApi = createApi({
    reducerPath: "buildSettingsApi",
    baseQuery: fetchBaseQuery({
        baseUrl: import.meta.env.VITE_BASE_API_URL,
        prepareHeaders: async headers => {
            const token = await getAuthToken();

            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }

            return headers;
        }
    }),
    tagTypes: ["BuildSettings"],
    endpoints: builder => ({
        getBuildSettings: builder.query<BuildSettings[], { companyId: string; buildId: string }>({
            query: query => `v1/api/build-settings/${query.companyId}?companyId=${query.companyId}&buildId=${query.buildId}`,
            providesTags: ["BuildSettings"]
        }),
        createBuildSettings: builder.mutation<BuildSettings, { companyId: string; buildSettings: Partial<BuildSettings> }>({
            query: ({ companyId, buildSettings }) => ({
                url: `v1/api/build-settings/${companyId}`,
                method: "POST",
                body: buildSettings
            }),
            invalidatesTags: ["BuildSettings"]
        }),
        updateBuildSettings: builder.mutation<BuildSettings, { companyId: string; id: string; buildSettings: Partial<BuildSettings> }>({
            query: ({ companyId, id, buildSettings }) => ({
                url: `v1/api/build-settings/${companyId}/${id}`,
                method: "PATCH",
                body: buildSettings
            }),
            invalidatesTags: ["BuildSettings"]
        })
    })
});

export const { useGetBuildSettingsQuery, useCreateBuildSettingsMutation, useUpdateBuildSettingsMutation } = buildSettingsApi;
